/* Smouz v8.42: optional gold details. Theme-side safeguard; not checkout validation. */
(() => {
  'use strict';
  const configNode = document.getElementById('smouz-riviera-config');
  if (!configNode || window.SmouzRiviera) return;
  const cfg = JSON.parse(configNode.textContent);
  const floors = new Set(cfg.floorIds.map(Number));
  const root = (cfg.root || '/').replace(/\/?$/, '/');
  const money = cents => new Intl.NumberFormat('nl-NL', { style: 'currency', currency: cfg.currency || 'EUR' }).format(cents / 100);
  let queue = Promise.resolve(), cachedCart = null;
  const enqueue = task => { const next = queue.then(task, task); queue = next.catch(() => {}); return next; };
  const fetchCart = async () => {
    const response = await fetch(root + 'cart.js', { credentials: 'same-origin', cache: 'no-store' });
    if (!response.ok) throw new Error('De winkelwagen kon niet worden gecontroleerd. Probeer het opnieuw.');
    return response.json();
  };
  function packs(value) {
    const n = Number(String(value).replace(',', '.'));
    if (!Number.isFinite(n) || n < 0.1 || n > 10000) return null;
    let best = null;
    for (let b = 0; b <= Math.ceil(n / 25); b++) {
      const a = Math.max(0, Math.ceil((n - b * 25) / 10));
      const total = a * 10 + b * 25;
      if (!best || total < best.total || (total === best.total && a + b < best.ten + best.twentyFive)) best = {ten:a, twentyFive:b, total};
    }
    return best;
  }
  function corrections(cart) {
    const allowed = cart.items.some(item => floors.has(Number(item.product_id)) && item.quantity > 0);
    const updates = {}; let plateCount = 0;
    cart.items.forEach(item => {
      const id = Number(item.product_id);
      if (id !== cfg.stripProductId && id !== cfg.plateProductId) return;
      if (!allowed) updates[item.key] = 0;
      else if (id === cfg.plateProductId) {
        const keep = plateCount ? 0 : 1;
        plateCount += keep;
        if (item.quantity !== keep) updates[item.key] = keep;
      }
    });
    return updates;
  }
  async function normalize(cart, sections) {
    const updates = corrections(cart);
    if (!Object.keys(updates).length) return {cart, changed:false};
    const response = await fetch(root + 'cart/update.js', {
      method:'POST', credentials:'same-origin', headers:{'Content-Type':'application/json'},
      body:JSON.stringify({updates, ...(sections ? {sections, sections_url:location.pathname} : {})})
    });
    if (!response.ok) throw new Error('De gouden extra’s konden niet worden bijgewerkt. Controleer uw winkelwagen.');
    const updated = await response.json();
    return {cart:updated, changed:true};
  }
  const remember = cart => {
    cachedCart = cart;
    document.querySelectorAll('[data-rm-options]').forEach(update);
  };
  function data(block) {
    if (!block._rmData) {
      const p = JSON.parse(block.querySelector('[data-rm-data]').textContent);
      const variant = (p.strip?.variants || []);
      block._rmData = {
        ten:variant.find(v => v.title === '10 meter'),
        twentyFive:variant.find(v => v.title === '25 meter'),
        plate:p.plate?.variants?.[0]
      };
    }
    return block._rmData;
  }
  function selection(block) {
    const d = data(block), strip = block.querySelector('[data-rm-strip]').checked;
    const plate = block.querySelector('[data-rm-plate]').checked;
    const raw = block.querySelector('[data-rm-length]').value;
    const plan = strip ? packs(raw) : null;
    let price = 0, error = '';
    if (strip) {
      if (!plan) error = 'Vul een lengte in tussen 0,1 en 10.000 meter.';
      else {
        if ((plan.ten && !d.ten?.available) || (plan.twentyFive && !d.twentyFive?.available)) error = 'Een benodigd pakket is niet beschikbaar. Neem contact met ons op.';
        price += plan.ten * (d.ten?.price || 0) + plan.twentyFive * (d.twentyFive?.price || 0);
      }
    }
    if (plate && !d.plate?.available) error = 'Het gouden plaatje is momenteel niet beschikbaar.';
    if (plate) price += d.plate?.price || 0;
    return {d, strip, plate, plan, price, error};
  }
  function update(block) {
    if (!block.isConnected) return;
    const plateInput = block.querySelector('[data-rm-plate]');
    const exists = cachedCart?.items.some(i => Number(i.product_id) === cfg.plateProductId && i.quantity > 0);
    if (exists) plateInput.checked = false;
    plateInput.disabled = !!exists || !data(block).plate?.available;
    block.querySelector('[data-rm-plate-note]').textContent = exists ? 'Al toegevoegd aan uw winkelwagen' : 'Eén plaatje per bestelling';
    const s = selection(block);
    block.querySelector('[data-rm-length-panel]').hidden = !s.strip;
    block.querySelector('[data-rm-length]').disabled = !s.strip;
    const result = block.querySelector('[data-rm-result]');
    if (s.strip && s.plan && !s.error) {
      const parts = [];
      if (s.plan.ten) parts.push(s.plan.ten + ' × 10 meter');
      if (s.plan.twentyFive) parts.push(s.plan.twentyFive + ' × 25 meter');
      result.textContent = 'U ontvangt ' + s.plan.total + ' meter · ' + parts.join(' + ') + ' · ' + money(s.plan.ten * (s.d.ten?.price || 0) + s.plan.twentyFive * (s.d.twentyFive?.price || 0));
    } else result.textContent = s.strip ? s.error : '';
    block.querySelector('[data-rm-total]').hidden = !(s.strip || s.plate);
    block.querySelector('[data-rm-total-price]').textContent = s.error ? '—' : money(s.price);
    const input = block.querySelector('[data-rm-length]');
    input.setCustomValidity(s.strip && s.error ? s.error : '');
  }
  async function withExtras(payload, form, cart) {
    const block = form?.querySelector('[data-rm-options]');
    if (!block || !floors.has(Number(block.dataset.floorId))) return payload;
    const s = selection(block);
    if (s.error) throw new Error(s.error);
    const items = payload.items.slice();
    // Stable properties let repeated selections merge normally in the cart.
    const props = {'_smouz_riviera_extra':'1'};
    if (s.strip) {
      if (s.plan.ten) items.push({id:s.d.ten.id, quantity:s.plan.ten, properties:props});
      if (s.plan.twentyFive) items.push({id:s.d.twentyFive.id, quantity:s.plan.twentyFive, properties:props});
    }
    if (s.plate && !cart.items.some(i => Number(i.product_id) === cfg.plateProductId && i.quantity > 0)) items.push({id:s.d.plate.id, quantity:1, properties:props});
    return {...payload, items};
  }
  function request(url, options, form) {
    return enqueue(async () => {
      let payload;
      try { payload = JSON.parse(options.body); } catch (_) { return fetch(url, options); }
      const isAdd = /\/cart\/add(?:\.js)?(?:\?|$)/.test(url);
      if (isAdd && form?.querySelector('[data-rm-options]')) {
        const cart = await fetchCart();
        payload = await withExtras(payload, form, cart);
      }
      const response = await fetch(url, {...options, body:JSON.stringify(payload)});
      if (!response.ok) return response;
      // Correct before handing sections back to the theme; prevents stale totals after removal.
      try {
        const original = await response.clone().json();
        const cart = isAdd ? await fetchCart() : (Array.isArray(original.items) ? original : await fetchCart());
        const result = await normalize(cart, payload.sections);
        remember(result.cart);
        if (result.changed) {
          const body = isAdd ? {...original, sections:result.cart.sections || original.sections} : result.cart;
          return new Response(JSON.stringify(body), {status:200, headers:{'Content-Type':'application/json'}});
        }
      } catch (error) {
        // The original mutation succeeded: do not report it as a failed add and invite duplicates.
        console.warn('[Smouz Riviera]', error);
        window.dispatchEvent(new CustomEvent('showAlert', {detail:{message:error.message, type:'error'}}));
      }
      return response;
    });
  }
  const ensure = () => enqueue(async () => {
    const cart = await fetchCart(); const result = await normalize(cart);
    remember(result.cart); return result.changed;
  });
  const check = () => ensure().then(changed => { if (changed) location.reload(); }).catch(e => console.warn('[Smouz Riviera]', e));
  const init = () => {
    document.querySelectorAll('[data-rm-options]').forEach(block => {
      if (block.dataset.ready) return;
      block.dataset.ready = 'true'; update(block);
    });
  };
  document.addEventListener('input', e => { const b = e.target.closest('[data-rm-options]'); if (b) { b.querySelector('[data-rm-error]').hidden=true; update(b); } });
  document.addEventListener('change', e => { const b = e.target.closest('[data-rm-options]'); if (b) update(b); });
  document.addEventListener('submit', e => {
    const block = e.target.querySelector?.('[data-rm-options]'); if (!block) return;
    const s = selection(block);
    if (s.error) {
      e.preventDefault(); e.stopImmediatePropagation();
      const error = block.querySelector('[data-rm-error]'); error.hidden=false; error.textContent=s.error;
      block.querySelector('[data-rm-length]').focus();
    }
  }, true);
  window.SmouzRiviera = {request, ensure, packs, corrections};
  const ready = () => {
    init(); check();
    // Native variant/section replacement can re-create the product form.
    let scheduled = false;
    new MutationObserver(records => {
      if (scheduled || !records.some(r => [...r.addedNodes].some(n => n.nodeType===1 && (n.matches?.('[data-rm-options]') || n.querySelector?.('[data-rm-options]'))))) return;
      scheduled=true; requestAnimationFrame(() => {scheduled=false; init();});
    }).observe(document.body, {childList:true,subtree:true});
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready, {once:true}); else ready();
  window.addEventListener('pageshow', e => {if (e.persisted) check();});
  window.addEventListener('themeCartOpened', check);
})();
